import { DependenciesPayload } from '@sxm-de/dev-kits/web-sdk/types';

export async function startOneTimePasscode(
    {
        identityId,
        otpOption,
        language,
    }: {
        identityId: string;
        otpOption: 'email' | 'phone';
        language: string;
    },
    { clientSdk }: DependenciesPayload,
) {
    try {
        await clientSdk.user.initializeOTP({
            identityId,
            otpOption: otpOption === 'email' ? 'EMAIL' : 'PHONE',
            otpContext: 'sign-in',
            language,
        });
    } catch (error: any) {
        /**
         * TODO:
         * Log error to error logger (not analytics).
         */
        throw new Error('SYSTEM');
    }
}
